import React from "react";
import {useField, useFormikContext} from 'formik';
import {FieldError} from "../Error/FieldError.jsx";
import {TimePicker as KendoTimePicker} from "@progress/kendo-react-dateinputs";

export const TimePicker = ({ label, required, style, disabled, onChange, ...otherProps }) => {
    const [field, meta] = useField(otherProps);
    const formikContext = useFormikContext();
    const { setFieldValue, values } = formikContext;

    // If disabled is a function, call it with the full form context
    const isDisabled = typeof disabled === 'function'
        ? disabled({
            ...formikContext,
            fieldName: otherProps.name,
            currentValue: values[otherProps.name]
        })
        : disabled;

    const handleChange = async (e) => {
        const newValue = e.target.value;

        if (onChange) {
            // Let the custom onChange handle field updates
            await onChange(e, {
                ...formikContext,
                fieldName: otherProps.name,
                newValue,
                previousValue: values[otherProps.name]
            });
        } else {
            // Default behavior: update Formik's state
            await setFieldValue(otherProps.name, newValue);
        }
    };


    return (
        <>
            {label && (
                <label htmlFor={otherProps.id || otherProps.name}>
                    {label}
                    {required && <span style={{ color: "red", marginLeft: 4 }}>*</span>}
                </label>
            )}
            <KendoTimePicker
                id={otherProps.id || otherProps.name}
                {...field}
                {...otherProps}
                onChange={handleChange}
                disabled={isDisabled}
            />
            <FieldError name={otherProps.name}/>
        </>
    );
};